import { FeatureFlag } from 'modules/featureFlags/types';
import { IdType, ImportType } from 'modules/domains/adminApp';

import { getAffectedIds } from './getAffectedIds';
import { getProjectIdFractionsFromSettings } from './getProjectIdFractionsFromSettings';
import { getOrgIdFractionsFromSettings } from './getOrgIdFractionsFromSettings';

export const getAffectedIdsFromSettings = (
  settings: FeatureFlag['settings'],
  idType: IdType,
  importType: ImportType,
) =>
  getAffectedIds(
    idType === IdType.Project
      ? getProjectIdFractionsFromSettings(settings)
      : getOrgIdFractionsFromSettings(settings),
    importType,
  );
